<template>
	
	<svg :width="width" :height="height" :aria-labelledby="iconName" viewBox="0 0 78 82" fill="none" xmlns="http://www.w3.org/2000/svg">
		<title :id="iconName" lang="en">{{ iconName }} icon</title>
		<path d="M58.5 81.9H78V62.4H67.6V71.5H58.5V81.9Z" fill="#CA66D2"/>
		<path d="M78 23.4V3.9H67.6V9.08734C66.6815 14.3851 64.3041 19.348 60.7063 23.4H78Z" fill="#FFD029"/>
		<path d="M78 42.9V23.4H60.7063C60.326 23.8283 59.9321 24.2464 59.5249 24.6537C59.1904 24.9881 58.8487 25.3135 58.5 25.6298V37.9039C61.4269 36.2142 64.146 34.1371 66.5772 31.706C66.9254 31.3577 67.2664 31.0036 67.6 30.6437V42.9H78Z" fill="#BBE400"/>
		<path d="M78.0001 62.4V42.9H67.6001V62.4H78.0001Z" fill="#1FB7EE"/>
		<path d="M39 81.9H58.5V71.5H39V81.9Z" fill="#9135F0"/>
		<path d="M39 33.1553V43.1288C45.9052 43.1288 52.6217 41.2975 58.5 37.9039V25.6298C53.173 30.4614 46.2254 33.1553 39 33.1553Z" fill="#81CC00"/>
		<path d="M19.5 81.9H39V71.5H19.5V81.9Z" fill="#605AF6"/>
		<path d="M19.5 25.6298C24.827 30.4614 31.7746 33.1553 39 33.1553V43.1288C32.0948 43.1288 25.3783 41.2975 19.5 37.9039V25.6298Z" fill="#4CDC00"/>
		<path d="M0 62.4V81.9H19.5V71.5H10.4V62.4H0Z" fill="#8972C8"/>
		<path d="M10.4 9.08737V3.9H0V23.4H17.2937C13.6959 19.348 11.3185 14.3851 10.4 9.08737Z" fill="#FFDB06"/>
		<path d="M0 23.4V42.9H10.4V30.6438C10.7336 31.0036 11.0746 31.3577 11.4228 31.706C13.854 34.1371 16.5731 36.2142 19.5 37.9039V25.6298C19.1513 25.3135 18.8096 24.9881 18.4751 24.6537C18.0679 24.2464 17.674 23.8283 17.2937 23.4H0Z" fill="#79EC00"/>
		<path d="M0 42.9V62.4H10.4V42.9H0Z" fill="#0FC4EA"/>
		<ellipse cx="26.0001" cy="3.99454" rx="4.16" ry="3.99454" fill="#FFB946"/>
		<ellipse cx="52.5201" cy="3.99454" rx="4.16" ry="3.99454" fill="#FFB946"/>
		<g filter="url(#filter0_d)">
			<path d="M10.4001 35.1V30.42C10.7338 30.7798 11.0747 31.134 11.423 31.4822C18.7369 38.7961 28.6567 42.9051 39.0001 42.9051C49.3436 42.9051 59.2634 38.7961 66.5773 31.4822C66.9255 31.134 67.2665 30.7798 67.6001 30.42V35.1C67.2665 35.4598 66.9255 35.814 66.5773 36.1622C59.2634 43.4761 49.3436 47.5851 39.0001 47.5851C28.6567 47.5851 18.7369 43.4761 11.423 36.1622C11.0747 35.814 10.7338 35.4598 10.4001 35.1Z" fill="#82899B"/>
		</g>
		<defs>
			<filter id="filter0_d" x="8.40015" y="30.42" width="61.2" height="21.1651" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
				<feOffset dy="2"/>
				<feGaussianBlur stdDeviation="1"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0.509804 0 0 0 0 0.537255 0 0 0 0 0.607843 0 0 0 0.5 0"/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
			</filter>
		</defs>
	</svg>

	
	<!--<svg :width="width" :height="height" viewBox="0 0 79 78" :aria-labelledby="iconName" fill="none" xmlns="http://www.w3.org/2000/svg">
		<title :id="iconName" lang="en">{{ iconName }} icon</title>
		<g filter="url(#filter0_d)" :fill="iconColor">
			<path d="M77 6.5C77 16.4456 73.0491 25.9839 66.0165 33.0165C58.9839 40.0491 49.4456 44 39.5 44C29.5544 44 20.0161 40.0491 12.9835 33.0165C5.95088 25.9839 2 16.4456 2 6.5H11.5899C11.5899 13.9022 14.5304 21.0013 19.7646 26.2355C24.9987 31.4696 32.0978 34.4101 39.5 34.4101C46.9022 34.4101 54.0013 31.4696 59.2354 26.2354C64.4696 21.0013 67.4101 13.9022 67.4101 6.5H77Z" fill="#192A3E" fill-opacity="0.3"/>
		</g>
		<circle cx="26.6667" cy="4" r="4" fill="#FFB946"/>
		<circle cx="50.6667" cy="4" r="4" fill="#FFB946"/>
		<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="3" width="75" height="75">
			<path d="M2 3H12V78H2V3Z" fill="#C4C4C4"/>
			<path d="M67 68V78H12V68H67Z" fill="#C4C4C4"/>
			<path d="M67 3H77V78H67V3Z" fill="#C4C4C4"/>
		</mask>
		<g mask="url(#mask0)">
			<rect x="2" y="21.75" width="18.75" height="18.75" fill="#79EC00"/>
			<rect x="2" y="40.5" width="18.75" height="18.75" fill="#0FC4EA"/>
			<rect x="2" y="3" width="18.75" height="18.75" fill="#FFDB06"/>
			<rect x="2" y="59.25" width="18.75" height="18.75" fill="#8972C8"/>
			<rect x="20.75" y="21.75" width="18.75" height="18.75" fill="#4CDC00"/>
			<rect x="20.75" y="40.5" width="18.75" height="18.75" fill="#00AAFD"/>
			<rect x="20.75" y="3" width="18.75" height="18.75" fill="#FFC473"/>
			<rect x="20.75" y="59.25" width="18.75" height="18.75" fill="#605AF6"/>
			<rect x="39.5" y="21.75" width="18.75" height="18.75" fill="#81CC00"/>
			<rect x="39.5" y="40.5" width="18.75" height="18.75" fill="#118BFA"/>
			<rect x="39.5" y="3" width="18.75" height="18.75" fill="#FFAC6A"/>
			<rect x="39.5" y="59.25" width="18.75" height="18.75" fill="#9135F0"/>
			<rect x="58.25" y="21.75" width="18.75" height="18.75" fill="#BBE400"/>
			<rect x="58.25" y="40.5" width="18.75" height="18.75" fill="#1FB7EE"/>
			<rect x="58.25" y="3" width="18.75" height="18.75" fill="#FFD029"/>
			<rect x="58.25" y="59.25" width="18.75" height="18.75" fill="#CA66D2"/>
		</g>
		<mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="3" width="75" height="38">
			<path d="M77 3.5C77 13.4456 73.0491 22.9839 66.0165 30.0165C58.9839 37.0491 49.4456 41 39.5 41C29.5544 41 20.0161 37.0491 12.9835 30.0165C5.95088 22.9839 2 13.4456 2 3.5H11.5899C11.5899 10.9022 14.5304 18.0013 19.7646 23.2355C24.9987 28.4696 32.0978 31.4101 39.5 31.4101C46.9022 31.4101 54.0013 28.4696 59.2354 23.2354C64.4696 18.0013 67.4101 10.9022 67.4101 3.5H77Z" fill="#C4C4C4"/>
		</mask>
		<g mask="url(#mask1)">
			<rect x="2" y="21.75" width="18.75" height="18.75" fill="#79EC00"/>
			<rect x="2" y="40.5" width="18.75" height="18.75" fill="#0FC4EA"/>
			<rect x="2" y="3" width="18.75" height="18.75" fill="#FFDB06"/>
			<rect x="20.75" y="21.75" width="18.75" height="18.75" fill="#4CDC00"/>
			<rect x="20.75" y="40.5" width="18.75" height="18.75" fill="#00AAFD"/>
			<rect x="20.75" y="3" width="18.75" height="18.75" fill="#FFC473"/>
			<rect x="39.5" y="21.75" width="18.75" height="18.75" fill="#81CC00"/>
			<rect x="39.5" y="40.5" width="18.75" height="18.75" fill="#118BFA"/>
			<rect x="39.5" y="3" width="18.75" height="18.75" fill="#FFAC6A"/>
			<rect x="58.25" y="21.75" width="18.75" height="18.75" fill="#BBE400"/>
			<rect x="58.25" y="40.5" width="18.75" height="18.75" fill="#1FB7EE"/>
			<rect x="58.25" y="3" width="18.75" height="18.75" fill="#FFD029"/>
		</g>
		<defs>
			<filter id="filter0_d" x="0" y="6.5" width="79" height="41.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
				<feOffset dy="2"/>
				<feGaussianBlur stdDeviation="1"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
			</filter>
		</defs>
	</svg>-->
</template>

<script>
export default {
	name: "JobBagIcon",
	props: {
		iconName: {
			type: String,
			default: 'jobbag-logo'
		},
		width: {
			type: [Number, String],
			default: 78
		},
		height: {
			type: [Number, String],
			default: 82
		},
		iconColor: {
			type: String,
			default: 'currentColor'
		}
	}
}
</script>